<div class="card-title" translate>dashboard.schedule.business.order-status</div>
<div *ngIf="!isLoading else loading" class="order-status-container">
	<button type="button" class="order-status" 
		*ngIf="{ disabled: scheduleBusinessOrderQuantities?.qtyInProduction === undefined || scheduleBusinessOrderQuantities?.qtyInProduction === 0} as qtyInProductionRipple"
		[class.copo-clickable]="!qtyInProductionRipple.disabled"
		[matRippleDisabled]="qtyInProductionRipple.disabled"
		(click)="!qtyInProductionRipple.disabled && viewDetails('qtyInProduction')" mat-ripple>
		<mat-icon svgIcon="in_production"></mat-icon>
		<div class="order-status-item" translate>order-tracking.in.production</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ scheduleBusinessOrderQuantities?.qtyInProduction || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: scheduleBusinessOrderQuantities?.qtyAvailableReadyToShip === undefined || scheduleBusinessOrderQuantities?.qtyAvailableReadyToShip === 0 } as qtyAvailableReadyToShipRipple"
		[class.copo-clickable]="!qtyAvailableReadyToShipRipple.disabled"
		[matRippleDisabled]="qtyAvailableReadyToShipRipple.disabled"
		(click)="!qtyAvailableReadyToShipRipple.disabled && viewDetails('qtyAvailableReadyToShip')" mat-ripple>
		<mat-icon svgIcon="in_stock"></mat-icon>
		<div class="order-status-item" translate>schedule-business-order.plant-stock</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ scheduleBusinessOrderQuantities?.qtyAvailableReadyToShip || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: scheduleBusinessOrderQuantities?.qtyBlocked === undefined || scheduleBusinessOrderQuantities?.qtyBlocked === 0} as qtyBlockedRipple"
		[class.copo-clickable]="!qtyBlockedRipple.disabled"
		[matRippleDisabled]="qtyBlockedRipple.disabled"
		(click)="!qtyBlockedRipple.disabled && viewDetails('qtyBlocked')" mat-ripple>
		<mat-icon svgIcon="stock_blocked"></mat-icon>
		<div class="order-status-item" translate>schedule-business-order.stock-blocked</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ scheduleBusinessOrderQuantities?.qtyBlocked || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: scheduleBusinessOrderQuantities?.qtyAvailableInTransit === undefined || scheduleBusinessOrderQuantities?.qtyAvailableInTransit === 0} as qtyAvailableInTransitRipple"
		[class.copo-clickable]="!qtyAvailableInTransitRipple.disabled"
		[matRippleDisabled]="qtyAvailableInTransitRipple.disabled"
		(click)="!qtyAvailableInTransitRipple.disabled && viewDetails('qtyAvailableInTransit')" mat-ripple>
		<mat-icon svgIcon="in_transit"></mat-icon>
		<div class="order-status-item" translate>schedule-business-order.in-transit-stock</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ scheduleBusinessOrderQuantities?.qtyAvailableInTransit || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: scheduleBusinessOrderQuantities?.qtyAvailableInConsignment === undefined || scheduleBusinessOrderQuantities?.qtyAvailableInConsignment === 0 } as qtyAvailableInConsignmentRipple"
		[class.copo-clickable]="!qtyAvailableInConsignmentRipple.disabled"
		[matRippleDisabled]="qtyAvailableInConsignmentRipple.disabled"
		(click)="!qtyAvailableInConsignmentRipple.disabled && viewDetails('qtyAvailableInConsignment')" mat-ripple>
		<mat-icon svgIcon="consignment_stock"></mat-icon>
		<div class="order-status-item" translate>order-card.batches-consignment-stock</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ scheduleBusinessOrderQuantities?.qtyAvailableInConsignment || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
	</button>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<div class="card-block-footer mobile-hide">
	<button type="button" mat-button color="primary" (click)="viewDetails()">
		<span translate>order-tracking.card.delivery-date.view-details</span>
		<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
	</button>
</div>
